import FormController from './FormController';

export default FormController;
